<template>
  <div id="app" class="bg-gray-50">
    <Navbar />
    <slot></slot>
    <Footer />
  </div>
</template>

<script>
import Navbar from "../components/Navbar.vue";
import Footer from "../components/Footer.vue";

export default {
  components: {
    Navbar,
    Footer
  }
};
</script>

<style>
#app {
  font-family: pnova-reg, Avenir, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
h1,
h2 {
  font-family: pnova-bold, Avenir, sans-serif;
}

h3,
h4 {
  font-family: pnova-semibold, Avenir, sans-serif;
}

.font-medium {
  font-family: pnova-semibold, Avenir, sans-serif;
}

.font-bold {
  font-family: pnova-bold, Avenir, sans-serif;
}

@font-face {
  font-family: "pnova-reg";
  src: url("../assets/fonts/proxima-nova-soft-regular-webfont.eot");
  src: url("../assets/fonts/proxima-nova-soft-regular-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/proxima-nova-soft-regular-webfont.woff") format("woff"),
    url("../assets/fonts/proxima-nova-soft-regular-webfont.ttf")
      format("truetype"),
    url("../assets/fonts/proxima-nova-soft-regular-webfont.svg") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "pnova-med";
  src: url("../assets/fonts/proxima-nova-soft-medium-webfont.eot");
  src: url("../assets/fonts/proxima-nova-soft-medium-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/proxima-nova-soft-medium-webfont.woff") format("woff"),
    url("../assets/fonts/proxima-nova-soft-medium-webfont.ttf")
      format("truetype"),
    url("../assets/fonts/proxima-nova-soft-medium-webfont.svg") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "pnova-semibold";
  src: url("../assets/fonts/proxima-nova-soft-semibold-webfont.eot");
  src: url("../assets/fonts/proxima-nova-soft-semibold-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/proxima-nova-soft-semibold-webfont.woff")
      format("woff"),
    url("../assets/fonts/proxima-nova-soft-semibold-webfont.ttf")
      format("truetype"),
    url("../assets/fonts/proxima-nova-soft-semibold-webfont.svg") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "pnova-bold";
  src: url("../assets/fonts/proxima-nova-soft-bold-webfont.eot");
  src: url("../assets/fonts/proxima-nova-soft-bold-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/proxima-nova-soft-bold-webfont.woff") format("woff"),
    url("../assets/fonts/proxima-nova-soft-bold-webfont.ttf") format("truetype"),
    url("../assets/fonts/proxima-nova-soft-bold-webfont.svg") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
</style>
